// extracted by mini-css-extract-plugin
module.exports = {"modal":"submit-modal_modal__2gMcw","modalHeader":"submit-modal_modalHeader__2SGW9","closeIcon":"submit-modal_closeIcon__k8s9e","modalBody":"submit-modal_modalBody__12izp"};